import {
    GoingUtils,
    StorageUtils,
    AssertUtils,
    QueryCommand
} from "goingutils";

export default {
    name: "upload-file-mixins",
    data: function () {
        let _bid = this.value||this.businessId || GoingUtils.getUUid(32);
        const token = StorageUtils.getSessionItem("sessionId");

        return {
            fileSuffix :[
                "bmp", "jpg", "png", "jpeg", "tif", "gif", "pcx", "tga", "exif", "fpx", "svg", "psd", "cdr", "pcd", "dxf", "ufo", "eps", "ai", "raw", "WMF", "webp"
            ],
            loadingFlag: false,
            headers: {
                "Blade-Auth": `bearer ${token}`,
                Authorization: `Basic c2FiZXI6c2FiZXJfc2VjcmV0`
            },
            bid: _bid,
            uploadFileId: '',
            fileNumbersLimit: this.fileNumbers,
            formateAry: [],
            uploadList: [],
            fileObj: {
                fileNames: [],
                fileIds: []
            },
            uploadAction: `${window.SysConfigUtils.go_eplat_adress}${window.projectName.file}/attachment/upload`,
            fileDivId: GoingUtils.getUUid(12),
            posData: {
                ...this.params,
                businessId: _bid,
                businessType: this.businessType,
                businessClass:this.businessClass,
                access_token: StorageUtils.getSessionItem("sessionId")
            }
        };
    },
    computed: {
        //获取上传类型
        getUploadFormat() {
            if (this.fileType === "img" || this.fileType === "image") {
                this.formateAry = ["jpg", "jpeg", "png", "gif"];
            } else if (this.fileType === 'excel') {
                this.formateAry = ["xls", "xlsx"];
            }
            return this.formateAry;
        },
        uploadStyle() {
            return {
                display: "inline-block"
            };
        },
        imgStyle() {
            return {
                width: this.iconWidth - 10 + "px",
                height: this.iconHeight - 10 + "px",
                margin: "5px"
            };
        },
        iconStyle() {
            return {
                fontSize: this.iconSize + "px"
            };
        },
        iconDivStyle() {
            return {
                width: this.iconWidth + "px",
                height: this.iconHeight + "px",
                lineHeight: this.iconHeight + "px"
            };
        }
    },
    props: {
        businessClass:{
            type: String,
            default: '无'
        },
        businessType:{
            type: String,
            default: '无'
        },
        businessId:{},
        //下载标志
        downFlag: {
            type: Boolean,
            default: true
        },
        //是否可以删除
        showDelete: {},
        //是否预览
        showPreview: {
            type: Boolean,
            default: true
        },
        //系统参数
        params: {
            type: Object,
            default: () => {
                return {};
            }
        },
        //文件类型
        fileType: {
            type: String,
            default: "all"
        },
        //是否是encryption上传
        encryption: {
            type: Boolean,
            default: false
        },
        //附件上传大小限制
        maxSize: {
            type: Number,
            default: 2048
        },
        value: {},
        //是否可以多选
        multiple: {
            type: Boolean,
            default: true
        },
        //附件上传个数
        fileNumbers: {
            type: Number,
            default: 5
        },
        //图标的宽度
        iconWidth: {
            type: [String, Number],
            default: 58
        },
        //图标的高度
        iconHeight: {
            type: [String, Number],
            default: 58
        },
        //图标的类型
        iconType: {
            type: String,
            default: "md-add"
        },
        //图标的字体大小
        iconSize: {
            type: [String, Number],
            default: 50
        }
    },
    methods: {
        getImgSrc(imgItem){
            return window.SysConfigUtils.go_web_client_address + `${projectName.file}/attachment/showImg/` + imgItem.id;
        },
        isImage(img){
            if(img==='png'||img==='jpg'||img==='gif'||img==='jpeg'){
                return true;
            }else{
                return false;
            }
        },
        downFile() {
            if (AssertUtils.isNotEmpty(this.fileTempId)) {
                //执行下载操作
                window.location.href = `${window.projectName.file}/attachment/download/` + this.fileTempId;
            }
            return false;
        },
        showImage(fileId) {
            return `${window.projectName.file}/attachment/showImg/` + fileId;
        },
        //上传之前校验附件的个数
        handleBeforeUpload() {
            let flag = true;
            if (this.beforeUpload != null && AssertUtils.isFunction(this.beforeUpload)) {
                flag = this.beforeUpload();
            }
            if (!flag) {
                return false;
            }
            GoingUtils.showLoading("附件上传中");
            if (this.multiple) {
                const check =
                    this.uploadList.length < this.fileNumbersLimit;
                if (!check) {
                    GoingUtils.showErrorMessage("每次最多上传" + this.fileNumbersLimit + "个文件.", this);
                }
                return check;
            } else {
                return true;
            }
        },
        //根据附件id删除附件
        deleteAttachment(fileId) {
            let queryCommand = new QueryCommand({
                url: `${window.projectName.file}/attachment/delFile`,
            });
            queryCommand.executeQuery({
                params: {businessId:this.businessId,fileId:fileId},
                successFun: (datas) => {

                },
            });
        },
        //处理删除操作
        handleRemove(file) {
            let id = file.response.result.propValues[0][0];
            this.deleteAttachment(id);
        },
        //处理上传错误
        handleError() {
            this.loadingFlag=false;
            GoingUtils.closeLoading();
            GoingUtils.showErrorMessage("上传失败", this);
        },
        //处理附件超出标准
        handleMaxSize(file) {
            this.loadingFlag = false;
            GoingUtils.closeLoading();
            GoingUtils.showErrorMessage("文件  " + file.name + " 太大，文件大小大于了" + Math.floor(this.maxSize / 1024) + "MB.");
        },
        //处理附件的格式不正确
        handleFormatError(file) {
            this.loadingFlag = false;
            GoingUtils.closeLoading();
            GoingUtils.showErrorMessage("文件格式 " + file.name + " 不正确, 请选择" + this.formateAry.join(" 或 "));
        },
        //上传完成后对相应信息进行处理
        dealUploadFile(fileIdAry) {
            //将上传成功的fileId存储起来
            this.uploadFileId = fileIdAry[0];
        },
        // 判断文件类型
        setFileType(obj) {
            let result;
            result = this.fileSuffix.some((item) => {
                return item === obj.fileType;
            });
            if (!result) {
                obj.fileType = "other";
            }
        },
        //计算文件大小
        setFileSize(obj) {
            if (obj.fileSize == 0) {
                obj.fileSize = "0B";
            } else if (obj.fileSize < 1024) {
                obj.fileSize = obj.fileSize + "B";
            } else if (obj.fileSize < 1048576) {
                obj.fileSize = (obj.fileSize / 1024).toFixed(2) + "KB";
            } else if (obj.fileSize < 1073741824) {
                obj.fileSize = (obj.fileSize / 1048576).toFixed(2) + "MB";
            } else {
                obj.fileSize = (obj.fileSize / 1073741824).toFixed(2) + "GB";
            }
        },
        //处理附件上传成功事件
        handleSuccess(res) {
            GoingUtils.closeLoading();
            if (res.data && res.data.length > 0) {
                let fileIds = [],
                    fileNames = [];
                res.data.forEach(function (item) {
                    fileIds.push(item["id"]);
                    fileNames.push(item["fileName"]);
                });
                //设置文件的类型
                this.setFileType(res.data[0]);
                //设置文件的大小
                this.setFileSize(res.data[0]);
                this.$emit("addFile", fileIds);
                //对上传的数据进行一个处理
                this.dealUploadFile(fileIds);
                // //附件上传后的事件
                if (AssertUtils.isFunction(this.afterUploadFile)) {
                    //对上传后的数据进行处理
                    this.afterUploadFile({
                        fileType:res.data[0].fileType,
                        fileId: fileIds.join(GoingUtils.relChart),
                        fileName: fileNames.join(GoingUtils.relChart),
                        fileObj:res.data[0],
                    });
                }
                this.$emit('handleSuccess',{
                    fileType:res.data[0].fileType,
                    fileId: fileIds.join(GoingUtils.relChart),
                    fileName: fileNames.join(GoingUtils.relChart),
                    fileObj:res.data[0],
                })
                return;
            }
            //如果存在错误信息则提示用户
            GoingUtils.showErrorMessage(res.msg);
        },
        //删除上次提交的附件
        clearPreUploadFile() {
            //清空这次数据之前 删除上次上传的数据
            if (this.uploadFileId != null) {
                // this.delFileById(this.uploadFileId);
            }
        },
        //存在fieldId 但没有附件名称但时候 则根据附件id获取附件名字
        loadFileName(fileId) {
            let queryCommand = new QueryCommand({
                url: `${window.projectName.file}/attachment/` + fileId,
                method: "GET"
            });
            queryCommand.executeQuery({
                successFun: (backData) => {
                    this.fileTempName = backData.data["fileName"];
                }
            });
        },
    },
    mounted() {},
    components: {}
};



// WEBPACK FOOTER //
// ./goingsrc/vueCom/ctlMixins/UploadFileMixins.js